// ADR-022 — single render-boundary source for the per-jurisdiction StateFilerId
// label (`feedback_treasurer_first_copy`). Moved out of `FinanceSetupCard` so the
// finance settings form AND the onboarding capture-once field render one source of
// truth, jurisdiction-aware. Keyed by the campaign's `rulesetCode` (same as the
// JSON ruleset filename stem under apps/api/RuleData/rulesets/).

export const STATE_FILER_ID_LABELS: Record<string, string> = {
  // FEC-011: federal committee ID (C00…) binds to StateFilerId like every
  // other jurisdiction; the FEC builder reads StateFilerId, not a separate FecId.
  FEDERAL: 'FEC Committee ID',
  AL: 'Alabama Committee ID (FCPA)',
  FL: 'Florida Filer ID',
  GA: 'Georgia Filer ID',
  LA: 'Louisiana Filer ID',
  VA: 'Virginia COMET Filer ID',
  // ADR-073 — MDCRIS calls the committee's id its "Filing Entity ID" (digits-only, 7–8 digits).
  MD: 'MDCRIS Filing Entity ID',
  // The ID ELEC eFile assigns the committee when it registers its reporting cycle.
  NJ: 'ELEC Filer ID',
};

/**
 * Per-jurisdiction label for the StateFilerId input. Generic "State Filer ID"
 * fallback so any unmapped (or not-yet-known) ruleset still renders sensibly.
 */
export function stateFilerIdLabel(rulesetCode: string | null | undefined): string {
  if (!rulesetCode) return 'State Filer ID';
  return STATE_FILER_ID_LABELS[rulesetCode.toUpperCase()] ?? 'State Filer ID';
}
